<div class="addcontact-container dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" (click)="onClose()">close</mat-icon>
  <div mat-dialog-title>
    <div class="addcontact-title">
      <div class="title-search">
        <div class="help" l10nTranslate>searchContact.addContacts</div>
      </div>
    </div>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="note" l10nTranslate>searchContact.note</div>
    <div class="search-contact-box">
      <div class="searchcontact-input">
        <div class="addcontact-search">
          <mat-form-field appearance="outline">
            <input
              matInput
              #searchBox
              class="searchBox"
              [formControl]="searchUser"
              type="search"
              [placeholder]="'recordsSearch.searchConatcts' | xTranslate"
            />
            <!-- NOTE: this i is being used to render font-awesome icon, but might be caught by sonarqube. Resolve it as "won't fix" -->
            <i class="fa fa-search searchIcon"></i>
          </mat-form-field>
        </div>
      </div>

      <div class="add-contact-dropdowns">
        <div>
          <label>{{ 'admin.country' | xTranslate | titlecase }}</label>
        </div>
        <mat-form-field class="select add-contact-dropdown" appearance="outline">
          <mat-select
            hideSingleSelectionIndicator="true"
            disableOptionCentering
            panelClass="languagedrop-position"
            id="country"
            [value]="selectedCountry"
            [placeholder]="selectedCountry"
            (selectionChange)="catalogSelection($event)"
          >
            <mat-option [ngClass]="'select-option'" *ngFor="let item of countriesCatalog" [value]="item.value">
              {{ item.label | uppercase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="contact-checkbox">
        <mat-checkbox l10nTranslate (change)="searchContacts()" [(ngModel)]="cbreOnly">
          searchContact.cbreOnly
        </mat-checkbox>
      </div>
    </div>

    <div class="contact-card" *ngFor="let contact of contactList; let i = index">
      <div class="circle-container" [ngStyle]="{ 'background-color': i | getColor }">
        <span>{{ contact.name | getContactInitials }}</span>
      </div>

      <div class="content-wrapper">
        <div class="contact-title" *ngIf="contact.name">{{ contact.name }}</div>
        <div class="email" *ngIf="contact.role">{{ contact.role }}</div>
        <div class="email" *ngIf="contact.phone">{{ contact.phone }}</div>
        <div class="email" *ngIf="contact.email">{{ contact.email }}</div>
      </div>
      <div>
        <div class="contact-bgcolor">
          <div class="contactCheck">
            <div>
              <!-- max 3 contacts can be selected -->
              <mat-checkbox
                [disabled]="!contact.checked && selectedContacts.length === 3"
                [(ngModel)]="contact.checked"
                (change)="contactChecked($event.checked, contact.id)"
              ></mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-flat-button color="primary" class="btn-submit" (click)="onCreate()" l10nTranslate>
      searchContact.save
    </button>
  </div>
</div>
